import * as memberApi from '../services/members.service';
import Vue from 'vue';
import _ from 'lodash';
import { orderService } from '@/store/services/order.service';

const state = {
  members: [],
  conferences: []
};

// Getters
const getters = {
  getMembers: state => {
    return state.members;
  }
};

const ignoredFields = [
  'createdAt', 'id', 'updatedAt', '__v', '_id'
];
const convertCommitees = function(member) {
  const commitees = [];
  for (const c in member.commitees) {
    if (ignoredFields.indexOf(c) === -1 && member.commitees[c] === true) {
      commitees.push(c);
    }
  }
  return commitees;
};

// Actions
const actions = {

  async fetchMembers({ commit }) {
    const members = await memberApi.fetchMembers();
    for (const m in members) {
      members[parseInt(m)].commitees = convertCommitees(members[parseInt(m)]);
    }
    commit('fetch', members);
    return members;
  },

  async add({ state, commit }, { memberInfo }) {
    // Transform the commitees into an object
    const commitees = {};
    if (memberInfo.commitees) {
      for (const c of memberInfo.commitees) {
        commitees[c] = true;
      }
    }
    memberInfo.commitees = commitees;

    const member = await memberApi.addMember(memberInfo);
    member.commitees = convertCommitees(member);
    commit('edit', member);
    return state.members;
  },

  async update({ state, commit }, { id, memberInfo }) {
    // Transform the commitees into an object
    const commitees = {};
    if (memberInfo.commitees) {
      for (const c of memberInfo.commitees) {
        commitees[c] = true;
      }
    }
    memberInfo.commitees = commitees;

    const member = await memberApi.editMember(id, memberInfo);
    member.commitees = convertCommitees(member);
    commit('edit', member);
    return state.members;
  },

  async delete({ state, commit }, { id }) {
    await memberApi.removeMember(id);
    commit('remove', id);
    return state.members;
  },

  async conferenceToCome({ state, commit }) {
    const conferences = await orderService.retrieveConferencesToCome();
    Vue.set(state, 'conferences', conferences);
  }
};

// Mutations
const mutations = {
  'fetch'(state, members) {
    Vue.set(state, 'members', members);
  },
  'edit'(state, member) {
    const index = _.findIndex(state.members, m => m.id === member.id);
    if (index !== -1) {
      Vue.set(state.members, index, member);
    }
    else {
      Vue.set(state.members, _.size(state.members), member);
    }
  },
  'remove'(state, id) {
    const index = _.findIndex(state.members, m => m.id === id);
    if (index >= 0) {
      Vue.delete(state.members, index);
    }
  }
};

export const members = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
